import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useTopTierDistribution = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [topTierDistributionData, setTopTierDistributionData] = useState<any[]>([]);

    const onTopTierDistributionDataError = (err: AxiosError<ErrorHttpResponse>) => {
        setTopTierDistributionData([]);
    };

    const onTopTierDistributionDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<TopTierDistributionInsightData[]>) => {
        // toast.success('TopTierDistribution insight fetched successfully.');
        setTopTierDistributionData(Array.isArray(data) ? data : []);
    };

    const getTopTierDistributionDataInsight = (path: string) => {
        const url: HttpConfig = {
            url: `${path}`,
            method: 'get',

        };
        request(url, onTopTierDistributionDataSuccess, setLoading, onTopTierDistributionDataError);
    };

    return { getTopTierDistributionDataInsight, loading, topTierDistributionData };
};

export default useTopTierDistribution;

interface TopTierDistributionInsightData {
    year: number,
    month: number,
    monthName: string,
    totalCompanies: number,
    platinumCount: number,
    goldCount: number,
    silverCount: number,
    riskCount: number;
}
